<template>
	<div :id="blok._uid" class="flex flex-col py-lg md:px-2xl">
		<div class="mx-auto my-lg">
			<v-icon
				v-if="iconName"
				class="w-auto text-12xl text-red-500"
				:icon="iconName"
			/>

			<nuxt-picture
				v-else-if="image?.filename"
				:key="image.filename"
				:src="image.filename"
				provider="storyblok"
				loading="lazy"
				height="96"
				width="96"
				class="w-auto text-12xl text-red-500"
			/>
		</div>

		<div class="mb-2">
			<p class="text-center font-sans-narrow text-xl font-bold">
				{{ blok?.title }}
			</p>
		</div>

		<div>
			<p class="text-center hyphens-auto">{{ blok?.content }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<
		BlokComponent,
		{component: "sb-product-safety" | "sb-product-safety-container"}
	>;
}>();

const iconName = computed(() => properties.blok.icon);
const image = computed(() => properties.blok.image);
</script>
